import Utils from "../../Utils";

const strict = true;

const defaultState = function () {
  return {
    active: false,
    forceLogout: false,
    errorText: null,
    onClickBtnClb: null
  };
};

const state = defaultState();

const getters = {
  isActive: state => state.active,
  forceLogout: state => state.forceLogout,
  errorText: state => state.errorText,
  onClickBtnClb: state => state.onClickBtnClb
};

const mutations = {
  reset(state) {
    const s = defaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  /**
   * Sometimes the error variable already contains the key of the message to be shown;
   * Instead sometimes the error variable is the error object coming from the response;
   */
  setError(state, error) {
    let errorMsg = null;
    let forceLogout = false;
    let isAlreadyAMsg = error
      ? typeof error === "string"
        ? true
        : false
      : false;
    if (isAlreadyAMsg) {
      errorMsg = error;
    } else {
      let errorHeaders = error
        ? error
          ? error.response
            ? error.response.headers
            : null
          : null
        : null;
      // sometimes the headers object is not inside the response object
      if (!errorHeaders) {
        errorHeaders = error ? error.headers : null;
      }
      // case for main.js file
      if (!errorHeaders) {
        errorMsg = error.errorMsg;
      } else {
        let exceptionType = Utils.getXOnairExceptionType(errorHeaders);
        let exceptionMsg = Utils.getXOnairExceptionMessage(errorHeaders);
        if (exceptionType && exceptionMsg) {
          // com.bizmatica.onair.core.model.runtime.security.AuthorizationException
          if (exceptionType === "AuthorizationException") {
            errorMsg = "dialog.error.keycloak-authorization";
            forceLogout = true;
          }
          // com.bizmatica.onair.core.model.ManagedAppNotInitializedCalledException
          if (exceptionType === "ManagedAppNotInitializedCalledException") {
            errorMsg = "dialog.error.sessionExpired";
          }
          // nest.common.NotAuthorizedException
          if (exceptionType === "NotAuthorizedException") {
            errorMsg = "dialog.error.keycloak-authorization-expired";
            forceLogout = true;
          }
          // nest.common.InvalidVerificationCodeException
          if (exceptionType === "InvalidVerificationCodeException") {
            errorMsg = "verifyContact.errors.invalidOtp";
          }
          // nest.common.UpdateContactDataException
          if (exceptionType === "UpdateContactDataException") {
            errorMsg = "verifyContact.errors.contactData";
          }
          // nest.common.InvalidSlotException
          if (exceptionType === "InvalidSlotException") {
            if (exceptionMsg.startsWith("Invalid slot request")) {
              errorMsg = "bookingWizard.recap.errors.wrongSlotSelection";
            }
          }
          // nest.common.MemberProfileMissingDataException
          if (exceptionType === "MemberProfileMissingDataException") {
            errorMsg = "bookingWizard.recap.errors.missingContactData";
          }
          // nest.common.UpdateIbanException
          if (exceptionType === "UpdateIbanException") {
            errorMsg = "profile.iban.errorDialog.text";
          }
          // nest.common.MemberNucleoFamiliareException
          if (exceptionType === "MemberNucleoFamiliareException") {
            errorMsg = "profile.nucleoFamiliare.errorDialog.text";
            forceLogout = true;
          }
        }
      }
    }
    state.active = true;
    state.forceLogout = forceLogout;
    state.errorText = errorMsg || "dialog.error.genericError";
    state.onClickBtnClb = error?.callback ? error.callback : null;
  },
  setKeycloakError(state, payload) {
    state.active = true;
    state.forceLogout = true;
    state.errorText = payload?.errorMsg || "dialog.error.genericError";
    state.onClickBtnClb = null;
  }
};

const actions = {
  closeErrorDialog({ commit, state, dispatch }) {
    if (state.forceLogout) {
      dispatch("doLogout", null, { root: true });
    }
    commit("reset");
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
